import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';

import Tooltip from '../../../components/ui/Tooltip';

// PNG indirme ikon düğmesi (2026-08-03 kullanıcı isteği: metin düğmesi yerine ikon +
// hover'da uygulamanın KENDİ Tooltip bileşeniyle "PNG İndir" balonu). Dört grafik yüzeyi
// (HaShimmerCard, FunnelPlot, SurvivalCurve, MetricTrendChart) aynı bileşeni kullanır —
// data-role çağırandan gelir, testler role üzerinden saymaya devam eder.
const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: ${({ theme }) => theme.colors.primary.main};
  cursor: pointer;

  &:hover { background: ${({ theme }) => `${theme.colors.primary.main}11`}; }
`;

export default function PngDownloadButton({ onClick, dataRole }) {
  const { t } = useTranslation();
  const label = t('hrAnalytics.downloadPng');

  return (
    <Tooltip text={label}>
      <IconButton type="button" data-role={dataRole} aria-label={label} onClick={onClick}>
        <Download size={16} aria-hidden="true" />
      </IconButton>
    </Tooltip>
  );
}
